import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "Can I get a refund after paying the advance?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Refunds are not applicable once the project is initiated, which includes consultations, planning, or any backend setup. Partial refunds may be considered only if canceled within 3 days before work begins."
      }
    },
    {
      "@type": "Question",
      "name": "Is there a refund if I don’t like the design after theme approval?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Once a theme or layout is approved, design dissatisfaction is not eligible for a refund. Revisions can be done as per scope or with additional charges."
      }
    },
    {
      "@type": "Question",
      "name": "Will I be charged extra if theme or plugin prices increase?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. Clients must pay any increased cost of domains, themes, plugins, or tools if prices rise after proposal. These are third-party services and out of our control."
      }
    },
    {
      "@type": "Question",
      "name": "What if my project is delayed or I go inactive?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "If a project is delayed by the client or remains inactive for over 30 days without notice, it may be marked as abandoned. No refunds will be issued in such cases."
      }
    },
    {
      "@type": "Question",
      "name": "Are discounted or bundled service payments refundable?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No. Projects booked under special pricing, bundle offers, or prepaid packages are non-refundable due to prior resource allocation."
      }
    },
    {
      "@type": "Question",
      "name": "How can I request a refund?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You can email your refund request with full details to info@pankj.com. We will review and respond within 3–5 business days based on eligibility."
      }
    }
  ]
}


function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>

<title>Refund Policy – Pankaj | Freelance Website Designer in Gurgaon</title>
<meta name="description" content="Read the refund and cancellation policy for website design and development services by Pankaj, a freelance website designer in Gurgaon. Learn about project cancellation terms, third-party charges, and maintenance support." />
<meta name="keywords" content="refund policy website designer, web design cancellation terms, website development refund, pankaj freelance designer refund, gurgaon web designer terms, refund policy web design company, freelance web developer india" />
<meta property="og:title" content="Refund Policy – Pankaj | Freelance Website Designer in Gurgaon" />
<meta property="og:description" content="View our official refund policy covering project cancellations, plugin/theme costs, SSL, maintenance, and more. Transparency for all web design clients." />
<meta property="og:url" content="https://www.pankj.com/refund-policy" />
<meta property="og:site_name" content="Pankaj Singh – Website Designer in Gurgaon" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<meta name="twitter:title" content="Refund Policy – Pankaj | Website Design Services Gurgaon" />
<meta name="twitter:description" content="Detailed refund and cancellation policy for web design and development services by Pankaj. Includes third-party charges, plugin/theme conditions, and project delivery terms." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />
<link rel="canonical" href="https://www.pankj.com/refund-policy" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />
 <h1 className="multiple_effects" id="text3d">Refund Policy</h1>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.webp" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">
<section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Refund Policy</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
  <p><strong>Effective Date:</strong> July 12, 2025</p>
  <p><strong>Website:</strong> <a href="https://www.pankj.com">www.pankj.com</a></p>
  <p><strong>Email:</strong> <a href="mailto:info@pankj.com">info@pankj.com</a></p>

  <p>
    At Pankaj Kumar Singh, we are committed to providing high-quality and personalized website design and development services.
    To maintain clarity, professionalism, and trust between both parties, we have outlined the following Refund Policy.
    This policy is intended to clearly define the circumstances under which a refund may or may not be issued.
  </p>

  <h3>1. Project Initiation and Consultation</h3>
  <p>Once a project has been discussed, accepted, and an initial payment has been made, it is considered initiated. This includes:</p>
  <ul>
    <li>Initial discussions and consultations</li>
    <li>Planning of scope and timeline</li>
    <li>Design research and project coordination</li>
  </ul>
  <p>Due to the time, effort, and resources invested from the beginning, <strong>no refunds</strong> will be issued once the project has been initiated and the advance payment is received.</p>

  <h3>2. Project Cancellation by Client</h3>
  <p>We understand that clients may occasionally need to cancel a project. Refund eligibility in such cases depends on the progress and timing:</p>

  <h5>a. Cancellation Before Work Has Begun</h5>
  <p>If cancellation occurs within 3 days of payment and before any design or development work has started, a partial refund of up to 50% may be granted, covering:</p>
  <ul>
    <li>Time spent in consultation</li>
    <li>Communication and admin tasks</li>
    <li>Planning costs</li>
    <li>Payment processing fees</li>
  </ul>

  <h5>b. Cancellation After Work Has Started</h5>
  <p>
    If cancellation occurs after any work has started — such as design drafts, development, or setup — <strong>no refund</strong> will be issued.
    Work begins immediately upon project confirmation.
  </p>

  <h5>c. Inactive or Delayed Projects</h5>
  <p>If the client becomes unresponsive or delays the project for over 30 days without notice, the project will be considered inactive and no refund will be issued. A reactivation fee may apply.</p>

  <h5>d. Discounted or Prepaid Package Deals</h5>
  <p>Projects under discounts or prepaid bundles are non-refundable under any circumstances due to the reduced pricing and resource commitment.</p>

  <h3>3. Design Dissatisfaction After Theme or Layout Approval</h3>
  <p>Once a theme or layout is approved by the client, the project proceeds accordingly. If dissatisfaction is raised later:</p>
  <ul>
    <li>It will not qualify for a refund</li>
    <li>Subjective design preference is not considered a failure of service</li>
  </ul>
  <p>Reasonable revisions are allowed as per the proposal; further changes may be billable.</p>

  <h3>4. Scope Creep and Additional Work</h3>
  <p>Requests beyond the original project scope are billed separately. Examples include:</p>
  <ul>
    <li>Extra pages</li>
    <li>New plugin integrations</li>
    <li>Advanced or custom features</li>
  </ul>
  <p>Clients are informed of any extra charges in advance.</p>

  <h3>5. Domain, Hosting, Theme & Plugin Costs</h3>

  <h5>a. Price Fluctuations</h5>
  <p>If domain, hosting, or plugin prices increase after quotation, clients must pay the updated amount and service handling charges.</p>

  <h5>b. Premium Plugins or Theme Add-ons</h5>
  <p>Requested features requiring paid plugins or themes must be purchased by the client. Implementation only begins after client approval.</p>

  <h5>c. Theme Bundled Plugins</h5>
  <p>Some themes include bundled premium plugins. These are limited to single-use licenses. For full access, clients must buy separate licenses.</p>

  <h3>6. SSL Certificates, Email Setup & Website Maintenance</h3>

  <h5>a. SSL Certificates</h5>
  <p>Free SSLs are installed where supported. Paid SSLs (e.g., wildcard SSL) and setup incur additional client charges.</p>

  <h5>b. Business Email Setup</h5>
  <p>We assist with email setup through services like Zoho or Google Workspace. Clients bear the subscription cost. Configuration support may be billed separately.</p>

  <h5>c. Website Maintenance</h5>
  <ul>
    <li>Maintenance is not included in the development fee</li>
    <li>Plans available on monthly/yearly basis</li>
    <li>On-demand support is billed hourly or per task</li>
    <li>Non-maintained sites are the client's responsibility</li>
  </ul>

  <h3>7. Final Project Delivery and Handover</h3>
  <p>After delivery and handover of all credentials and files, the project is considered complete. Following this:</p>
  <ul>
    <li>No refunds will be processed</li>
    <li>Bugs reported within 7 days will be fixed if within scope</li>
    <li>New features or changes post-delivery will be quoted separately</li>
  </ul>

  <h3>8. Payment Disputes or Chargebacks</h3>
  <p>Clients must not initiate chargebacks without contacting us. If done:</p>
  <ul>
    <li>All delivered rights will be revoked</li>
    <li>Legal action may be taken</li>
    <li>Future services may be denied</li>
  </ul>

  <h3>9. How to Request a Refund (If Eligible)</h3>
  <p>To request a refund, email us with the following:</p>
  <ul>
    <li>Send to: <a href="mailto:info@pankj.com">info@pankj.com</a></li>
    <li>Subject Line: Refund Request – [Your Project Name]</li>
    <li>Details and reason for refund</li>
  </ul>
  <p>We will review your request within 3–5 business days.</p>

  <h3>10. Final Disclaimer</h3>
  <p>
    By starting a project or making any payment to Pankaj Kumar Singh, the client accepts this Refund Policy in full.
    We advise reading it carefully before engaging in a project. Clear policies help us deliver reliable, professional service.
  </p>


          </div>

        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
